import {Image} from 'antd';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-css';

const Projects = ({data}) => {

  if (!data || !data.projects) {
    return <div className={'text-center'}>Loading...</div>;
  }

  const filteredProjects = data.projects;

  const breakpointColumnsObj = {
    default: 3,
    1100: 2,
    700: 2,
    500: 2,
  };

  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-4 pt-4 bg-primary-50'}>
      <div className={'max-w-7xl w-full'}>
        {/* <div className={'flex flex-wrap mb-4 mt-8 justify-center'}>
          {filters.map(item => (
            <Button
              key={item.value}
              onClick={() => setFilter(item.value)}
              type={filter === item.value ? 'primary' : 'default'}
              className={'mr-2 mb-2 lg:w-48 h-14 text-lg font-semibold'}
            >
              {item.label}
            </Button>
          ))}
        </div> */}

        <div className={'flex flex-wrap justify-center'}>
          {filteredProjects.map(project => (
            <div key={project.id} className={'lg:m-4 w-full rounded-3xl lg:px-8 px-5 lg:py-8 py-6'}>
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className={'flex justify-center'}
                columnClassName={'lg:pl-4 lg:mr-4 mr-2'}
              >
                {project.Photos &&
                  project.Photos.map((photo, index) => (
                    <Image
                      key={index}
                      src={photo}
                      alt={project.name}
                      className={'mb-4 lg:rounded-xl rounded-lg '}
                    />
                  ))}
              </Masonry>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

Projects.propTypes = {
  data: PropTypes.shape({
    projects: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        location: PropTypes.string,
        scope: PropTypes.string,
        timeline: PropTypes.string,
        tags: PropTypes.arrayOf(PropTypes.string),
        heroPhotos: PropTypes.arrayOf(PropTypes.string),
        detailShot: PropTypes.string,
      }),
    ),
  }),
};

export default Projects;
